module.exports = __webpack_public_path__ + "img/bitvavo.b65440ee.png";